
import { eoRendererMixin, metaDataMixin } from '~/mixins'

export default {
  mixins: [
    eoRendererMixin,
    metaDataMixin,
  ],
  layout: 'bijbelse-namen',
  async asyncData ({ $api, $config, $log, error }) {
    const slug = 'bijbelse-namen'
    const {
      data: {
        items: page = [],
      } = {},
    } = await $api.pages.getOneBySlug(slug, {
      domain: $config.preprEnvironmentDomainBijbelseNamen,
    })

    // check publication if exists and is complete
    if (!page || !page.length) {
      $log.warn(`Couldn't create '${slug}' page.`)
      return error({ statusCode: 404, message: 'Oeps! De pagina is niet gevonden' })
    }

    return page[0]
  },
  data () {
    return {
      id: null,
      title: null,
      subtitle: null,
      intro: null,
      environmentId: null,
      featuredVideo: null,
      keyword: null,
      hero: null,
      content: null,
      seo: null,
      slug: null,
      social: null,
      newsletter: {
        title: "Ontvang gratis het inspiratieboekje 'Bijbelse babynamen'!",
        description: "Je ontvangt dit boekje, met maar liefst 300 namen, per e-mail. Daarna krijg je nog 4 e-mails vol handige tips om je te helpen bij de naamkeuze, inspiratie voor originele teksten op het geboortekaartje én mooie artikelen over (geloofs)opvoeding. ",
        campaignId: "7017U000000osuFQAQ",
      },
    }
  },
  methods: {
    onSearch (keyword) {
      this.$router.push({
        path: '/bijbelse-namen/zoeken',
        query: {
          invoer: keyword,
        },
      })
    },
  },
}
